export function TablePlaceholder() {
  return <span className="text-[13px] font-semibold text-[#C7CCD4]">—</span>;
}
